import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-[#F5E6D3] text-[#3D2B1F] overflow-hidden" data-id="element-11">
      {/* Hero Content */}
      <div className="max-w-4xl mx-auto px-6 pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-12">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-13">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-14">
            <span className="inline-block px-3 py-1 mb-4 text-sm font-medium tracking-wide text-[#E8856C] bg-[#FFF8F0] rounded-full border border-[#E8856C]/20" data-id="element-15">
              Para mamás que ya no pueden con un tip más
            </span>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-[#3D2B1F]" data-id="element-16">
              Si estás gritando más de lo que quieres…{' '}
              <span className="italic text-[#E8856C]" data-id="element-17">esto es para ti.</span>
            </h1>

            <p className="text-lg md:text-xl text-[#3D2B1F]/80 mb-8 font-sans leading-relaxed" data-id="element-18">
              7 días para bajar el caos (sin ser la mamá perfecta).
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-19">
              <a href="#precio" className="bg-[#E8856C] hover:bg-[#D6745B] text-[#FFF8F0] px-8 py-4 rounded-full font-medium text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-20">
                Quiero mi guía — $19
                <ArrowRight className="w-5 h-5" data-id="element-21" />
              </a>
            </div>

            <div className="mt-6 flex items-center justify-center md:justify-start gap-2 text-sm text-[#3D2B1F]/70" data-id="element-22">
              <div className="flex text-[#E8856C]" data-id="element-23">
                <Star className="w-4 h-4 fill-current" data-id="element-24" />
                <Star className="w-4 h-4 fill-current" data-id="element-25" />
                <Star className="w-4 h-4 fill-current" data-id="element-26" />
                <Star className="w-4 h-4 fill-current" data-id="element-27" />
                <Star className="w-4 h-4 fill-current" data-id="element-28" />
              </div>
              <span data-id="element-29">Sistema probado por +500 mamás</span>
            </div>
          </div>

          {/* Product Image */}
          <div className="flex-1 w-full max-w-md md:max-w-full relative" data-id="element-30">
            <div className="absolute inset-0 bg-[#E8856C]/10 rounded-3xl transform rotate-3 scale-105 blur-lg" data-id="element-31"></div>
            <img src="https://cdn.magicpatterns.com/uploads/6CZV6Bhro6n5LAedoK4K7m/IMAGENPRODUCTO2.png" alt="Mamitas Latinas Ebook en iPad y iPhone" className="relative w-full h-auto rounded-2xl shadow-2xl transform transition-transform hover:scale-[1.02] duration-500" data-id="element-32" />
          </div>
        </div>
      </div>

      {/* Opening Lead - The Emotional Hook */}
      <div className="bg-[#FFF8F0] py-16 md:py-24 px-6" data-id="element-33">
        <div className="max-w-2xl mx-auto space-y-6 text-lg md:text-xl leading-relaxed text-[#3D2B1F]" data-id="element-34">
          <p className="font-serif text-2xl md:text-3xl italic text-[#E8856C] mb-8 border-l-4 border-[#E8856C] pl-6" data-id="element-35">
            Hay un momento que casi nadie dice en voz alta.
          </p>

          <p data-id="element-36">No porque no pase… sino porque da vergüenza.</p>

          <p data-id="element-37">
            Es cuando tu hijo te pide una cosa simple —agua, ayuda, atención— y
            por dentro sientes una ola de rabia o desesperación.
          </p>

          <p className="font-medium" data-id="element-38">No contra tu hijo. Contra todo.</p>

          <p data-id="element-39">
            Contra el ruido. Contra la casa. Contra la lista infinita. Contra el
            hecho de que tu cuerpo ya no te alcanza.
          </p>

          <p data-id="element-40">Y ahí aparece la frase venenosa:</p>

          <p className="font-serif text-xl italic text-[#3D2B1F]/80 bg-[#F5E6D3]/50 p-4 rounded-lg text-center" data-id="element-41">
            "¿Qué me pasa? ¿Por qué no puedo ser una buena mamá?"
          </p>

          <p data-id="element-42">La respuesta es más simple (y más dura) de lo que te han dicho:</p>

          <p className="font-bold text-[#E8856C] text-xl" data-id="element-43">
            No estás mal. Estás sobrecargada y sin sistema.
          </p>
        </div>
      </div>
    </section>;
}